<template>
  <div>
    <Head :title="`${role.name}`" />
    <div class="flex justify-start max-w-3xl mb-8">
      <h1 class="text-2xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/roles">Role</Link>
        <span class="font-medium text-indigo-400">/</span>
        {{ role.name }}
      </h1>
    </div>
    <div class="w-full bg-white rounded-md shadow">
      <form @submit.prevent="update">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <text-input v-model="form.name" :error="form.errors.name" class="w-full pb-8 pr-6 lg:w-1/2" label="Nama Role" maxlength="255" />
          <text-input v-model="form.guard_name" :error="form.errors.guard_name" class="w-full pb-8 pr-6 lg:w-1/2" label="Guard Name" maxlength="255" />
          <div class="w-full pb-8 pr-6 lg:w-1/2">
            <label for="permissions" class="form-label">Permission</label>
            <v-select v-model="form.permissions" :close-on-select="false" :deselect-from-dropdown="true" multiple :options="permissions" :reduce="permission => permission.id" label="name" placeholder="Pilih Permission" />
          </div>
        </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <loading-button :loading="form.processing" class="ml-auto btn-indigo" type="submit">
            <font-awesome-icon icon="fas fa-floppy-disk" class="mr-2" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    role: Object,
    permissions: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.role.name,
        guard_name: this.role.guard_name,
        permissions: this.role.permissions,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/roles/${this.role.id}`)
    },
  },
}
</script>
<style scoped>
:deep() {
  --vs-actions-padding: 15px 6px 10px 3px;
  --vs-selected-bg: #2980b9;
  --vs-selected-color: #ecf0f1;
  --vs-controls-color: #ecf0f1;

  --vs-dropdown-option--active-bg: #2980b9;
  --vs-dropdown-option--active-color: #ecf0f1;

  --vs-dropdown-option--deselect-bg: #9b59b6;
  --vs-dropdown-option--deselect-color: #ecf0f1;
}
</style>
